import _regeneratorRuntime from "babel-runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import { ASSETS_TOOLBAR, TEXT_TOOLBAR } from "./Types";
import ContextFactory from "../Context";
import { getImageMeta } from "../Misc/Image";
var IS_BUSY_FLAG = "isBusy";
var ASSETS_PAGE_SIZE = 20;
var FRAMES_PAGE_SIZE = 20;
var DEFAULT_STATE = {
  selectedToolbar: ASSETS_TOOLBAR,
  displayHelp: false,
  video: {},
  assets: {},
  frames: {},
  isPreviewEnabled: true,
  fontSettings: {
    fontFamily: "arial",
    fontSize: 40,
    lineHeight: 1.16,
    fill: "#000000",
    fontWeight: "normal",
    fontStyle: "normal"
  }
};
var EditorContext = (_temp = _class = function EditorContext(propagateMutation) {
  var _this = this;

  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _extends({}, DEFAULT_STATE);

  _classCallCheck(this, EditorContext);

  _initialiseProps.call(this);

  this.state = state;

  this._propagateMutation = function () {
    propagateMutation(_this);
  };
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setState = function (newState) {
    Object.keys(newState).map(function (key) {
      return _this2.state[key] = newState[key];
    });

    _this2._propagateMutation();
  };

  this.initializeState = function (state) {
    _this2.setState(_extends({}, DEFAULT_STATE, state, {
      selectedToolbar: TEXT_TOOLBAR
    }));
  };

  this.video = {
    _setVideoAttribute: function _setVideoAttribute(attribute, value) {
      var _extends2;

      _this2.setState({
        video: _extends({}, _this2.state.video, (_extends2 = {}, _extends2[attribute] = value, _extends2))
      });
    },
    setScale: function setScale(scale) {
      return _this2.video._setVideoAttribute("scale", scale);
    },
    setVideoProps: function setVideoProps(props) {
      return _this2.video._setVideoAttribute("props", props);
    },
    setCurrentTime: function setCurrentTime(currentTime) {
      _this2.video._setVideoAttribute("currentTime", currentTime);

      setTimeout(function () {
        return _this2.video._setVideoAttribute("currentTime", undefined);
      });
    }
  };
  this.assets = {
    _setAssetsAttribute: function _setAssetsAttribute(attribute, value) {
      var _extends3;

      _this2.setState({
        assets: _extends({}, _this2.state.assets, (_extends3 = {}, _extends3[attribute] = value, _extends3))
      });
    },
    isBusy: function isBusy() {
      return _this2.state.assets[IS_BUSY_FLAG];
    },
    hasAssets: function hasAssets() {
      return !!_this2.state.assets.assetsSource;
    },
    applyFilter: function applyFilter(filter, value) {
      if (!_this2.assets.isBusy()) {
        _this2.assets._setAssetsAttribute("appliedFilter", filter && value ? {
          filter: filter,
          value: value
        } : null);

        _this2.assets._setAssetsAttribute("appliedSearchTerm", null);

        _this2.assets._setAssetsAttribute("page", 0);

        _this2.assets._setAssetsAttribute("assets", []);

        _this2.assets.loadAssets();
      }
    },
    searchTimeout: null,
    applySearch: function applySearch(term) {
      _this2.assets._setAssetsAttribute("appliedSearchTerm", term);

      if (_this2.searchTimeout) {
        clearTimeout(_this2.searchTimeout);
      }

      _this2.searchTimeout = setTimeout(function () {
        _this2.searchTimeout = null;

        if (!_this2.assets.isBusy()) {
          _this2.assets._setAssetsAttribute("page", 0);

          _this2.assets._setAssetsAttribute("assets", []);

          _this2.assets.loadAssets();
        }
      }, 500);
    },
    loadMoreAssets: function loadMoreAssets() {
      if (_this2.assets.isBusy()) {
        return;
      }

      var _state$assets = _this2.state.assets,
          _state$assets$page = _state$assets.page,
          page = _state$assets$page === undefined ? 0 : _state$assets$page,
          _state$assets$hasMore = _state$assets.hasMore,
          hasMore = _state$assets$hasMore === undefined ? true : _state$assets$hasMore;

      if (!hasMore) {
        return;
      }

      _this2.assets._setAssetsAttribute("page", page + 1);

      _this2.assets.loadAssets();
    },
    loadAssets: function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _state$assets2, assetsSource, _state$assets2$page, page, appliedFilter, appliedSearchTerm, _state$assets2$assets, assets, rest, loadedAssets;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _state$assets2 = _this2.state.assets, assetsSource = _state$assets2.assetsSource, _state$assets2$page = _state$assets2.page, page = _state$assets2$page === undefined ? 0 : _state$assets2$page, appliedFilter = _state$assets2.appliedFilter, appliedSearchTerm = _state$assets2.appliedSearchTerm, _state$assets2$assets = _state$assets2.assets, assets = _state$assets2$assets === undefined ? [] : _state$assets2$assets, rest = _objectWithoutProperties(_state$assets2, ["assetsSource", "page", "appliedFilter", "appliedSearchTerm", "assets"]);

                if (!(!assetsSource || rest[IS_BUSY_FLAG])) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this2.assets._setAssetsAttribute(IS_BUSY_FLAG, true);

                _context.next = 6;
                return assetsSource(page * ASSETS_PAGE_SIZE, ASSETS_PAGE_SIZE, appliedFilter ? [appliedFilter] : null, appliedSearchTerm);

              case 6:
                loadedAssets = _context.sent;

                _this2.assets._setAssetsAttribute("assets", assets.concat(loadedAssets));

                _this2.assets._setAssetsAttribute("hasMore", loadedAssets.length >= ASSETS_PAGE_SIZE);

                _this2.assets._setAssetsAttribute(IS_BUSY_FLAG, false);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function loadAssets() {
        return _ref.apply(this, arguments);
      };
    }()
  };
  this.frames = {
    _setFramesAttribute: function _setFramesAttribute(attribute, value) {
      var _extends4;

      _this2.setState({
        frames: _extends({}, _this2.state.frames, (_extends4 = {}, _extends4[attribute] = value, _extends4))
      });
    },
    isBusy: function isBusy() {
      return _this2.state.frames[IS_BUSY_FLAG];
    },
    hasFrames: function hasFrames() {
      return !!_this2.state.frames.framesSource;
    },
    loadMoreFrames: function loadMoreFrames() {
      if (_this2.frames.isBusy()) {
        return;
      }

      var _state$frames = _this2.state.frames,
          _state$frames$page = _state$frames.page,
          page = _state$frames$page === undefined ? 0 : _state$frames$page,
          _state$frames$hasMore = _state$frames.hasMore,
          hasMore = _state$frames$hasMore === undefined ? true : _state$frames$hasMore;

      if (!hasMore) {
        return;
      }

      _this2.frames._setFramesAttribute("page", page + 1);

      _this2.frames.loadFrames();
    },
    getFrames: function getFrames() {
      var _state = _this2.state,
          filterFramesToCurrentResolution = _state.filterFramesToCurrentResolution,
          orientation = _state.orientation,
          frames = _state.frames;

      if (!filterFramesToCurrentResolution) {
        return frames;
      }

      var _frames$frames = frames.frames,
          loadedFrames = _frames$frames === undefined ? [] : _frames$frames;
      return _extends({}, frames, {
        frames: loadedFrames.filter(function (frame) {
          return frame.orientation === orientation;
        })
      });
    },
    selectFrame: function selectFrame(frameId) {
      _this2.frames._setFramesAttribute("selectedFrame", frameId);
    },
    loadFrames: function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _state$frames2, selectedFrame, framesSource, _state$frames2$page, page, _state$frames2$frames, frames, rest, loadedFrames, measuredFrames;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _state$frames2 = _this2.state.frames, selectedFrame = _state$frames2.selectedFrame, framesSource = _state$frames2.framesSource, _state$frames2$page = _state$frames2.page, page = _state$frames2$page === undefined ? 0 : _state$frames2$page, _state$frames2$frames = _state$frames2.frames, frames = _state$frames2$frames === undefined ? [] : _state$frames2$frames, rest = _objectWithoutProperties(_state$frames2, ["selectedFrame", "framesSource", "page", "frames"]);

                if (!(!framesSource || rest[IS_BUSY_FLAG])) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _this2.frames._setFramesAttribute(IS_BUSY_FLAG, true);

                _context3.next = 6;
                return framesSource(page * FRAMES_PAGE_SIZE, FRAMES_PAGE_SIZE);

              case 6:
                loadedFrames = _context3.sent;
                _context3.next = 9;
                return Promise.all(loadedFrames.map(function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(frame) {
                    var _ref4, width, height;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return getImageMeta(frame.url);

                          case 3:
                            _ref4 = _context2.sent;
                            width = _ref4.width;
                            height = _ref4.height;
                            return _context2.abrupt("return", _extends({
                              orientation: width >= height ? "landscape" : "portrait"
                            }, frame));

                          case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2["catch"](0);
                            return _context2.abrupt("return", null);

                          case 12:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2, [[0, 9]]);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 9:
                measuredFrames = _context3.sent;

                _this2.frames._setFramesAttribute("frames", frames.concat(measuredFrames.filter(function (val) {
                  return !!val;
                })));

                _this2.frames._setFramesAttribute("hasMore", loadedFrames.length >= FRAMES_PAGE_SIZE);

                _this2.frames._setFramesAttribute(IS_BUSY_FLAG, false);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function loadFrames() {
        return _ref2.apply(this, arguments);
      };
    }()
  };

  this.setHelpModalVisibility = function (visibility) {
    _this2.setState({
      displayHelp: visibility
    });
  };

  this.selectToolbar = function (toolbar) {
    return _this2.setState({
      selectedToolbar: toolbar
    });
  };

  this.setFontSettings = function (fontSettings) {
    return _this2.setState({
      fontSettings: fontSettings
    });
  };

  this.togglePreview = function () {
    return _this2.setState({
      isPreviewEnabled: !_this2.state.isPreviewEnabled
    });
  };

  this.setVideoPlayer = function (videoPlayer) {
    return _this2.videoPlayer = videoPlayer;
  };

  this.pauseVideo = function () {
    return _this2.videoPlayer && _this2.videoPlayer.pause();
  };
}, _temp);

var _ContextFactory = ContextFactory(EditorContext, "EditorContext"),
    withProvider = _ContextFactory.withProvider,
    consumeContext = _ContextFactory.consumeContext;

export { withProvider, consumeContext };